export const EARN_EXTENSION_CARD_DEFAULT_CATEGORY =
  'earn_extension_card_default_campaign'

export const SAFARI_LOCAL_STORAGE_KEY = 'safari_earn_card_tapped'
